export enum SystemFields {
    ENABLED,
    SORT,
    CREATEDATE,
    CREATEDBY,
    CHANGEDATE,
    CHANGEDBY,
    F_DICTIONARY,
    REPLICATIONID,
}
